module.exports = __webpack_public_path__ + "static/media/video-calendar.7a20eb0d.svg";